import React, { useState } from 'react';
import { PageHeader } from './PageHeader';
import './SettingsPage.css';

export const ThemePage: React.FC = () => {
  const [selectedTheme, setSelectedTheme] = useState<'light' | 'dark' | 'auto'>('light');

  return (
    <div className="page-container settings-page">
      <PageHeader title="Tema" />

      <div className="settings-content">
        <div className="settings-group">
          <h2 className="settings-group-title">Apariencia</h2>
          <div className="theme-options">
            <button 
              className={`theme-option ${selectedTheme === 'light' ? 'active' : ''}`}
              onClick={() => setSelectedTheme('light')}
            >
              <div className="theme-icon">☀️</div>
              <div className="theme-label">Claro</div>
              {selectedTheme === 'light' && <div className="theme-checkmark">✓</div>}
            </button>
            <button 
              className={`theme-option ${selectedTheme === 'dark' ? 'active' : ''}`}
              onClick={() => setSelectedTheme('dark')}
            >
              <div className="theme-icon">🌙</div>
              <div className="theme-label">Oscuro</div>
              {selectedTheme === 'dark' && <div className="theme-checkmark">✓</div>}
            </button>
            <button 
              className={`theme-option ${selectedTheme === 'auto' ? 'active' : ''}`}
              onClick={() => setSelectedTheme('auto')}
            >
              <div className="theme-icon">🔄</div>
              <div className="theme-label">Auto</div>
              {selectedTheme === 'auto' && <div className="theme-checkmark">✓</div>}
            </button>
          </div>
          <p className="settings-note">
            El tema "Auto" seguirá la configuración del sistema de tu dispositivo
          </p>
        </div>
      </div>
    </div>
  );
};

